import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionHead } from "./Portfolio";
import { SECTORS } from "@/data/sectors";

export const Sectors = () => (
  <div data-testid="sectors-section">
    <SectionHead
      eyebrow="Setores que servimos"
      title="Soluções de impressão 3D à medida do seu setor"
      subtitle="Da indústria à investigação, adaptamos tecnologia e material às exigências de cada aplicação. Produção 100% em Portugal."
    />
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
      {SECTORS.map((s) => (
        <Link
          key={s.slug}
          to={`/setores/${s.slug}`}
          data-testid={`sector-card-${s.slug}`}
          className="group bg-ax-card border border-ax-border rounded-xl p-6 hover:border-ax-orange/50 hover:-translate-y-1 transition-all"
        >
          <div className="w-11 h-11 rounded-lg bg-ax-orange/10 border border-ax-orange/30 flex items-center justify-center mb-4">
            <s.icon className="w-5 h-5 text-ax-orange" />
          </div>
          <h4 className="font-heading font-semibold text-ax-text">{s.name}</h4>
          <p className="text-sm text-ax-sub mt-2 leading-relaxed line-clamp-3">{s.intro}</p>
          <span className="mt-4 inline-flex items-center gap-1.5 text-sm text-ax-cyan group-hover:gap-2.5 transition-all">
            Ver soluções <ArrowRight className="w-4 h-4" />
          </span>
        </Link>
      ))}
    </div>
  </div>
);
